import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import './styles.css'

export default function Loading({ loading }) {
    return (
        <div className='load'>
            {
                loading &&
                <CircularProgress />
            }
        </div>
    );
}